import apiveiculoweb from '@/services/api-recebimentoweb';

let findTimeout = null;

export default {
  namespaced: true,

  state: {
    list: [],
    ordem: {},
    ordemFinalizar: false,
    itens: {},
    itemAtual: {},
    unidades: {},
    unidadesInseridas: [],
    loading: false,
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apiveiculoweb.get('veiculo', { params: { ...where, ...params } }),
        apiveiculoweb.get('veiculo/count', { params: where }),
      ]);

      return { data, total };
    },

    // CONSULTA COM CONTROLE DE CACHE
    async findWithCache({ commit, state }, { force, ttl } = {}) {
      if (!force && state.list?.length > 0) {
        return;
      }

      clearTimeout(findTimeout);

      const { data } = await apiveiculoweb.get('veiculo');

      commit('SET_LIST', data);

      if (ttl === Infinity) return;

      findTimeout = setTimeout(() => {
        commit('SET_LIST', null);
      }, ttl ?? 1000 * 60); // TTL -> Time To Live
    },

    verificaCompleto({ commit }, itens) {
      const finalizados = itens.filter((i) => i.ocidatafinalizado);
      commit('SET_ORDEM_FINALIZAR', finalizados.length === itens.length);
    },

    verificaUnidades(_, { inseridas, unidades }) {
      const normalize = obj =>
        JSON.stringify(
          Object.fromEntries(
            Object.entries(obj).sort(([a], [b]) => a.localeCompare(b))
          )
        );

      const normInseridas = inseridas.map(normalize);

      const diferencas = unidades.filter(
        u => !normInseridas.includes(normalize(u))
      );

      return {
        diferencas,
        resultado: diferencas.length === 0
      };
    },

    verificaQuantidade(_, { quantidade, inseridas}) {
      const soma = inseridas.reduce((t, i) => t + Number(i.ocuquantidade ?? 0), 0);
      console.log('check qtd', soma, Number(quantidade), soma === Number(quantidade))
      return {soma, resultado: soma === Number(quantidade)};
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    SET_ORDEM(state, ordem) {
      state.ordem = ordem ?? {};
    },
    CLEAR_ORDEM(state) {
      state.ordem = {};
    },
    SET_ITENS(state, itens) {
      state.itens = itens ?? {};
    },
    CLEAR_ITENS(state) {
      state.itens = {};
    },
    SET_ITEM_ATUAL(state, item) {
      state.itemAtual = item ?? {};
    },
    CLEAR_ITEM_ATUAL(state) {
      state.itemAtual = {};
    },
    SET_UNIDADES(state, unidades) {
      state.unidades = unidades ?? {};
    },
    CLEAR_UNIDADES(state) {
      state.unidades = {};
    },
    SET_UNIDADES_INSERIDAS(state, unidades) {
      state.unidadesInseridas = unidades;
    },
    ADD_UNIDADES_INSERIDAS(state, unidade) {
      state.unidadesInseridas.push(unidade ?? null);
    },
    DEL_UNIDADES_INSERIDAS(state, unidade) {
      const index = state.unidadesInseridas.findIndex((item) => JSON.stringify(item) === JSON.stringify(unidade));
      state.unidadesInseridas.splice(index, 1);
    },
    CLEAR_UNIDADES_INSERIDAS(state) {
      state.unidadesInseridas = [];
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ORDEM_FINALIZAR(state, value) {
      state.ordemFinalizar = value;
    }
  },
};
